import { Amplify } from 'aws-amplify';
import awsConfig from '../amplifyconfiguration.json';
import { fetchAuthSession } from 'aws-amplify/auth';

export const getApiName = () => {
    return awsConfig.aws_cloud_logic_custom[0]?.name;
};

export const getHeader = async () => {
    return {
        headers: {
            Authorization: (await fetchAuthSession()).tokens?.idToken?.toString(),
        },
    };
};

export const getSubPath = (header) => {
    if (header.headers.Authorization) {
        return '/private/api/';
    }
    return '/api/';
};

export const setParams = (url, params) => {
    if (params) {
        url += '?';
        let arrParams = [];
        for (const name in params) {
            arrParams.push(encodeURI(`${name}=${params[name] ? params[name] : ''}`));
        }
        url += arrParams.join('&');
    }

    return url;
};
